define((require) => {
    "use strict";

    var _                 = require("underscore"),
        EditorEvents      = require("shared/services/EditorEvents"),
        GroupAsset        = require("shared/ui/groups/GroupAsset"),
        GroupDescriptor   = require("shared/data/groups/GroupsDescriptor"),
        LoggedInUserState = require("shared/ui/user/LoggedInUserState"),
        Marionette        = require("marionette"),
        Permissions       = require("shared/security/Permissions"),
        template          = require("editor/ui/experience/editor/BreakpointAssignView.tpl"),
        Tooltip           = require("ui/common/Tooltip");

    /**
     * View for assigning the experiences to breakpoints.
     *
     * @class BreakpointAssignView
     * @constructor
     *
     * @cfg {GroupAssetCollection} collection The GroupAssetCollection.
     */
    return Marionette.ItemView.extend({

        template: template,

        useNewBreakpoints: false,

        ui: {
            ok:      ".ok-btn",
            cancel:  ".cancel-btn",
            selects: ".select-experience",
            update:  ".update-btn"
        },

        events: {
            "click @ui.ok": "saveBreakpoints",
            "click @ui.cancel": "close",
            "click @ui.update": "applyNewBreakpoints"
        },

        templateHelpers: function() {
            return {
                permissionToManage: Permissions.Privileges.CREATE.can(),
                assets: this.assets,
                experiences: this.experiences,
                breakpointModified: this.isBreakpointModified()
            };
        },

        initialize: function() {
            this.breakpointCollection = LoggedInUserState.get("companySettings").get("breakpoints");

            this.lowerBoundsInSetting = this.breakpointCollection.getLowerBounds();
            this.experiences = this.model.getSortedAssets();
        },

        onBeforeRender: function() {
            this.assets = this._getAssets();
        },

        onRender: function() {
            var thresholds = this.breakpointCollection.getThresholds();

            // There is no "and" if we only have one breakpoint.
            var thresholdsText = thresholds.length === 1 ?
                thresholds + "px" :
                _.initial(thresholds).join("px, ") + "px and " + _.last(thresholds) + "px";

            Tooltip.create(this.ui.update, {
                content: "The Breakpoint Settings have been changed to " + thresholdsText + ".",
                width: 200,
                placement: "top"
            });
        },

        // Update the flag of whether we should use the new breakpoint settings and rerender
        applyNewBreakpoints: function() {
            this.useNewBreakpoints = true;
            this.render();

            var eventProperties = {
                groupId: this.model.get("id"),
                groupType: this.model.get("type"),
                groupVersion: this.model.get("version"),
                groupPushedVersion: this.model.get("pushedVersion"),
                triggerOrigin: "BreakpointAssignModalUpdateButton"
            };

            EditorEvents.trigger(EditorEvents.constants.UPDATE_BREAKPOINT, eventProperties);
        },

        isBreakpointModified: function() {
            if (this.useNewBreakpoints) {
                return false;
            }

            return !this.model.compareThresholds(this.lowerBoundsInSetting);
        },

        getLowerBounds: function() {
            var breakpoints = this.model.getValues();

            if (!breakpoints.length || this.useNewBreakpoints) {
                breakpoints = this.lowerBoundsInSetting;
            }

            return _.sortBy(breakpoints, (breakpoint) => {
                return breakpoint.get("threshold");
            });
        },

        _getAssets: function() {
            var self = this,
                lowerBounds = this.getLowerBounds(),
                naming = this.breakpointCollection.generateNaming(lowerBounds.length - 1);

            return _.map(lowerBounds, (breakpoint, index) => {
                //  As a fallback, each breakpoint is associated with the first experience
                var experience = self.model.getAssetByThreshold(breakpoint.get("threshold")) || self.experiences[0];

                return [naming[index], breakpoint, experience];
            });
        },

        saveBreakpoints: function() {
            var self = this,
                updated = false,
                reassigned = false,
                assignedIds = _.pluck(self.ui.selects, "value"),
                assets = this.model.getAssets();

            _.each(assignedIds, (id, index) => {
                if (id !== self.assets[index][2].id) {
                    updated = true;
                }
            });

            // Don't do anything if there is no changes, so we don't bump up the model version
            if (updated || this.useNewBreakpoints) {
                var entries = _.map(this.getLowerBounds(), (breakpoint, index) => {
                    var experienceId = self.ui.selects[index].value,
                        experience = _.findWhere(self.experiences, {id: experienceId});

                    var l = assets.length;

                    while (l--) {
                        var asset = assets[l];
                        if (asset.get("id") === experienceId) {
                            assets.splice(l, 1);
                            break;
                        }
                    }

                    // Need a breakpoint clone, otherwise we can not detect breakpoint changes due to the same reference
                    return GroupAsset.asAsset(experience, breakpoint.clone(), GroupDescriptor.ValueType.BREAKPOINT);
                });

                // Make sure we remember all assets (experiences) not chosen by the user for a breakpoint...
                _.each(assets, (asset) => {
                    entries.push(GroupAsset.asAsset(asset, null, GroupDescriptor.ValueType.BREAKPOINT));
                });

                reassigned = true;

                self.model.get("entries").reset(entries);
                self.model.save();
            }

            var eventProperties = {
                groupId: self.model.get("id"),
                groupType: self.model.get("type"),
                groupVersion: self.model.get("version"),
                groupPushedVersion: self.model.get("pushedVersion"),
                triggerOrigin: "BreakpointAssignModalOkButton",
                reassigned: reassigned
            };

            EditorEvents.trigger(EditorEvents.constants.SAVE_BREAKPOINT, eventProperties);

            this.close();
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/editor/BreakpointAssignView.js